module.exports = __webpack_public_path__ + "common/account-eb46fefb5e0d3e591c5cc4e6c02949ae.svg";